export default "__VITE_ASSET__ddb84169__"